import _ from "lodash";
import React from "react";
import { Route, Routes } from "react-router-dom";
// import Sitemap from "./sitemap";

import Header from "components/common/short/headers/header";
import Footer from "components/common/short/footers/footer";

import Index from "./views-specials";
import Content from "./views-specials/content";
import Layout from "./views/layout";

import WebAppIndex from "./views-specials/webapp";

// import Feedback from "./views/feedback";

const LayoutView = (props) => {
  return (
    <Layout>
      <Header webApp={props.webApp} />
      {props.children}
      <Footer webApp={props.webApp} />
    </Layout>
  );
};

const RoutesMap = () => {
  return (
    <Routes>
      <Route
        path={`/`}
        element={
          <LayoutView>
            <Index />
          </LayoutView>
        }
      />


      <Route
        path={`/app`}
        element={
          <LayoutView webApp={true}>
            <WebAppIndex />
          </LayoutView>
        }
      />

      {/* <Route exact path="/we/*" component={Partners} /> */}
    </Routes>
  );
};

export default RoutesMap;
